<mat-toolbar class="topbar" style="background-color:white; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);">
  <app-branding [visibility]="visibility" [isVendor]="visibilityVendor"></app-branding>
  <!-- Mobile Menu -->
  <button mat-icon-button (click)="toggleMobileNav.emit()" *ngIf="!showToggle">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  <!-- --------------------------------------------------------------- -->

  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown -->
  <!-- --------------------------------------------------------------- -->

  <!-- Open Bids — always visible to all users -->
  <a [routerLink]="['/open-bid']" style="margin-right: 4px;" *ngIf="isLoggedIn &&!visibilityCustomer">
    <button mat-button style="color: #7a1c20; font-weight: 600; display: flex; align-items: center; gap: 4px;">
      <mat-icon class="d-flex align-items-center">
        <i-tabler name="clipboard-list" class="icon-18 d-flex"></i-tabler>
      </mat-icon>
      Open Bids
    </button>
  </a>

  <span class="flex-1-auto"></span>
  <!-- <a [routerLink]="['/workspace/brief']" target="_blank" *ngIf="isLoggedIn && !visibilityVendor "> -->
  <a [routerLink]="isNewBriefDisabled() ? null : ['/workspace/brief/new']" [target]="isNewBriefDisabled() ? '_self' : '_blank'"
    *ngIf="isLoggedIn && !visibilityVendor && team !== 'content'&& !isOnProfilePage()">
    <button mat-raised-button style="background-color: #7a1c20; color: white" [disabled]="isNewBriefDisabled()">
      <mat-icon class="d-flex align-items-center">
        <i-tabler name="message-2-plus" class="icon-18 d-flex"></i-tabler>
      </mat-icon>
      New Brief
    </button>
  </a>

  <!-- Ops Dashboard button — for internal users EXCEPT prodcontroller, who
       gets a Vendor Reports shortcut instead (see button below). -->
  <a [routerLink]="['/workspace/ops-console/dashboard']"
    *ngIf="isLoggedIn && !visibilityVendor && !visibilityCustomer && !isProdController">
    <button mat-raised-button style="background-color: #7a1c20; color: white">
      <mat-icon class="d-flex align-items-center">
        <i-tabler name="report-analytics" class="icon-18 d-flex"></i-tabler>
      </mat-icon>
      Ops Console
    </button>
  </a>

  <!-- Vendor Reports shortcut — replaces the Ops Console button only for
       the prodcontroller account, since that's their primary landing page. -->
  <a [routerLink]="['/workspace/ops-console/vendor-reports']" *ngIf="isLoggedIn && isProdController">
    <button mat-raised-button style="background-color: #7a1c20; color: white">
      <mat-icon class="d-flex align-items-center">
        <i-tabler name="report-search" class="icon-18 d-flex"></i-tabler>
      </mat-icon>
      Vendor Reports
    </button>
  </a>

  <!-- Project Heat Map — prodcontroller-only sibling of Vendor Reports.
       Route itself is also gated by ProdControllerOnlyGuard. -->
  <a [routerLink]="['/workspace/ops-console/heatmap']" *ngIf="isLoggedIn && isProdController" style="margin-left: 8px;">
    <button mat-raised-button style="background: linear-gradient(135deg, #D98C5A, #A8344A); color: white;">
      <mat-icon class="d-flex align-items-center">
        <i-tabler name="grid-pattern" class="icon-18 d-flex"></i-tabler>
      </mat-icon>
      Project Heat Map
    </button>
  </a>


  <div class="notification-dropdown" *ngIf="isLoggedIn && visibilityVendor">
    <button mat-icon-button [matMenuTriggerFor]="notificationMenu" aria-label="Notifications" color="accent"
      class="notification-bell-btn" [matTooltip]="unreadCount + ' unread notifications'"
      (click)="fetchVendorNotifications()">
      <i-tabler class="d-flex" name="bell"></i-tabler>
      <span class="custom-badge-tooltip" *ngIf="unreadCount > 0">
        {{unreadCount > 9 ? '9+' : unreadCount}}
      </span>
    </button>

    <mat-menu #notificationMenu="matMenu" class="notification-menu">
      <div class="notification-header">
        <span>Notifications</span>
        <span class="notification-count">{{unreadCount}} unread</span>
      </div>

      <div *ngIf="!notifications?.length" class="no-notifications">
        No notifications available
      </div>

      <div class="notification-list">
        <div *ngFor="let notification of notifications" class="notification-item" [class.unread]="!notification.is_read"
          (click)="markAsRead(notification.id)">
          <div class="notification-icon">
            <i-tabler [name]="notification.type === 'sample_accept' ? 'circle-check' : 'circle-x'"
              [ngClass]="{'text-green': notification.type === 'sample_accept', 'text-red': notification.type === 'sample_reject'}"
              class="icon-20 d-flex"></i-tabler>
            <span *ngIf="!notification.is_read" class="unread-dot"></span>
          </div>
          <div class="notification-content">
            <div class="notification-message">
              <div>{{ notification.title }}</div>
              <div class="notification-time">{{ formatRelativeTime(notification.created_at) }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="notification-header" *ngIf="unreadCount > 0" style="border-top: 1px solid #eee; cursor: pointer;"
        (click)="markAllVendorNotificationsAsRead()">
        <span style="color: #7a1c20; font-size: 12px;">Mark all as read</span>
      </div>
    </mat-menu>
  </div>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button [matMenuTriggerFor]="profilemenu" aria-label="Notifications" *ngIf="isLoggedIn">
    <img src="/assets/images/profile/user-1.jpg" class="rounded-circle object-cover" width="35" />
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
    <button mat-menu-item (click)="router.navigate(['/customers/profile'])" *ngIf="isLoggedIn && visibilityCustomer">
      <mat-icon class="d-flex align-items-center">
        <i-tabler name="user" class="icon-18 d-flex"></i-tabler>
      </mat-icon>
      Profile
    </button>
    <button (click)="router.navigate(['/vendors'])"
      *ngIf="isLoggedIn && !visibilityVendor && !visibilityCustomer && !isProdController" mat-menu-item>
      <mat-icon class="d-flex align-items-center">
        <i-tabler name="users" class="icon-18 d-flex"></i-tabler>
      </mat-icon>
      Vendors
    </button>
    <button mat-menu-item (click)="router.navigate(['/workspace/sales-console/customers'])"
      *ngIf="isLoggedIn && !visibilityVendor && !visibilityCustomer && !isProdController">
      <mat-icon class="d-flex align-items-center">
        <i-tabler name="address-book" class="icon-18 d-flex"></i-tabler>
      </mat-icon>
      Customers
    </button>
    <!-- <button mat-menu-item (click)="router.navigate(['workspace/brief/smartscope'])"  *ngIf="isLoggedIn && !visibilityVendor" >
      <mat-icon
        class="d-flex align-items-center"
      >
      <i-tabler name="message-2-plus" class="icon-18 d-flex"></i-tabler>
      </mat-icon>
      SmartScope(comming-soon)
    </button> -->
    <button mat-menu-item (click)="router.navigate(['/workspace/ops-console/dashboard'])"
      *ngIf="isLoggedIn && !visibilityVendor && !visibilityCustomer && !isProdController">
      <mat-icon class="d-flex align-items-center">
        <i-tabler name="report-analytics" class="icon-18 d-flex"></i-tabler>
      </mat-icon>
      Ops Console
    </button>
    <button mat-menu-item (click)="router.navigate(['/workspace/ops-console/vendor-reports'])"
      *ngIf="isLoggedIn && !visibilityVendor && !visibilityCustomer && !hideVendorReports">
      <mat-icon class="d-flex align-items-center">
        <i-tabler name="report-search" class="icon-18 d-flex"></i-tabler>
      </mat-icon>
      Vendor Reports
    </button>
    <button mat-menu-item (click)="router.navigate(['/workspace/ops-console/heatmap'])"
      *ngIf="isLoggedIn && isProdController">
      <mat-icon class="d-flex align-items-center">
        <i-tabler name="grid-pattern" class="icon-18 d-flex"></i-tabler>
      </mat-icon>
      Project Heat Map
    </button>
    <button mat-menu-item (click)="router.navigate(['/workspace/sales-console/dashboard'])"
      *ngIf="isLoggedIn && !visibilityVendor && !visibilityCustomer && !isProdController">
      <mat-icon class="d-flex align-items-center">
        <i-tabler name="chart-bar" class="icon-18 d-flex"></i-tabler>
      </mat-icon>
      Sales Console
    </button>
    <button mat-menu-item (click)="router.navigate(['/workspace/projects'])">
      <mat-icon class="d-flex align-items-center">
        <i-tabler name="list-check" class="icon-18 d-flex"></i-tabler>
      </mat-icon>
      Projects
    </button>
    <div class="p-x-12 m-t-12">
      <button mat-stroked-button color="primary" class="w-100" (click)="logout()">
        Logout
      </button>
    </div>
  </mat-menu>
</mat-toolbar>